import React, { Fragment } from "react";
import { WalletPoints } from "@jnext/ts-axios-wallet";
import './WalletInfoMiniBanner.scss';
import {useJCommonContext} from "../JCommonProvider";
export type WalletInfoMiniBannerProps = {
    walletData?: WalletPoints[],
    align?: "right" | "left";
};

export const WalletInfoMiniBanner: React.FC<WalletInfoMiniBannerProps> = ({ walletData, align = "right" }) => {
    const {getImageURL} = useJCommonContext();
    return (
        <Fragment>
            {
                !!walletData?.length && (
                    <div className={`wallet-banner-container ${align}`}>
                        <div className={`wallet-banner`}>
                            <div className={`wallet-banner-content `}>
                                {
                                    walletData?.map((point: WalletPoints, i: number) => {
                                        return (
                                            <div key={i} className='score-counter-points-container'>
                                                {point?.cmsConfig?.imageRef &&
                                                    <img aria-hidden={true} src={getImageURL(point?.cmsConfig?.imageRef)} />}
                                                {point?.number && <p className='points'>{point?.number}</p>}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                )
            }
        </Fragment>
    )
}

export default WalletInfoMiniBanner;
